(function() {
  var Automagic;

  Automagic = (function() {
    function Automagic(opt) {
      var i, j, len, ref, ref1, ref2, step;
      this.username = opt.username;
      if ($('.admin-header .logged-as').text().indexOf("Logged in as " + this.username) === -1) {
        return null;
      }
      this.masqueradeUser = (ref = opt.masqueradeUser) != null ? ref : null;
      if (this.masqueradeUser != null) {
        if ($('#primary_header a.dropdown-toggle>span:nth-child(2)').text().indexOf(this.masqueradeUser) === -1) {
          return null;
        }
      }
      if (opt.steps instanceof Array) {
        this.steps = opt.steps;
      } else {
        console.error('Error in class Automagic: steps must be an array');
      }
      ref1 = this.steps;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        step = ref1[i];
        if (!(step instanceof AutomagicStep)) {
          this.steps[i] = new AutomagicStep(step);
        }
      }
      this.autorun = (ref2 = opt.autorun) != null ? ref2 : false;
      if (this.autorun) {
        this.run();
      }
    }

    Automagic.prototype.run = function() {
      return this._runLoop();
    };

    Automagic.prototype._runLoop = function(i, time, doWait) {
      var step;
      if (i == null) {
        i = 0;
      }
      if (time == null) {
        time = 0;
      }
      if (doWait == null) {
        doWait = true;
      }
      if (this.steps[i] == null) {
        return;
      }
      step = this.steps[i];
      if (time >= step.maxWaitTime) {
        console.error("Error in class Automagic: step " + i + " timed out after " + time + "ms");
        return;
      }
      if (doWait && (step.wait != null)) {
        setTimeout((function(_this) {
          return function() {
            return _this._runLoop(i, 0, false);
          };
        })(this), step.wait);
        return;
      }
      if (!step.when()) {
        setTimeout((function(_this) {
          return function() {
            return _this._runLoop(i, time + step.pollInterval);
          };
        })(this), step.pollInterval);
        return;
      }
      if (step.waitAnother != null) {
        return setTimeout((function(_this) {
          return function() {
            step["do"]();
            return _this._runLoop(i + 1);
          };
        })(this), step.waitAnother);
      } else {
        step["do"]();
        return this._runLoop(i + 1);
      }
    };

    return Automagic;

  })();

}).call(this);
